export enum EcommerceTechTypeEnum {
  PAYMENT_LINK = 'PAYMENT_LINK',
  ECC_IPG = 'ECC_IPG',
  ECC_CARAT = 'ECC_CARAT'
}
